<template>
  <lazy-display-frozenpanetable-xy
    :nbx="nbx"
    :nby="nby"
    :default_width="body_cell_width_default"
    :variable_width_start_pos="variable_width_start_pos"
    :variable_widths="variable_widths"
    :default_height="body_cell_height_default"
    :variable_height_start_pos="variable_height_start_pos"
    :variable_heights="variable_heights"
    :horizontal_header_height="horizontal_header_cell_height_default"
    :vertical_header_width="vertical_header_cell_width_default"
    :style="`height: ${max_component_height}px;`"
    :vertical_header_containee_class="['bg-blue']"
    :body_containee_y_class="['columnstore-viewer-row']"
    @fetch_data="fetch_data"
    class="w-100"
  >
    <template #horizontalheader="{nbx, width}">
      <columnstore-viewer-column-header
        :key="nbx"
        :style="width"
        v-bind="arguments_for_header(nbx)"
        v-on="header_events(arguments_for_header(nbx).name)"
      />
    </template>

    <template #verticalheader="{nby, height}">
      <div
        :key="nby"
        :style="height"
        class="lazy-table-vertical-header text-truncate"
      >
        {{ nby }}
      </div>
    </template>
    <template #bodycell="{nbx, nby, width, height}">
      <columnstore-viewer-body-cell
        :tokey="`${nbx}x${nby}`"
        :toclass="class_for_coords(nbx, nby)"
        :tostyle="width + height"
        :text="data_for_coords(nbx, nby)"
      >
      </columnstore-viewer-body-cell>
    </template>
  </lazy-display-frozenpanetable-xy>
</template>

<!-- <template>
  <div>
    <lazy-display-frozenpanetable-xy
      :nbx="nbx"
      :nby="nby"
      :default_width="body_cell_width_default"
      :variable_width_start_pos="variable_width_start_pos"
      :variable_widths="variable_widths"
      :default_height="body_cell_height_default"
      :variable_height_start_pos="variable_height_start_pos"
      :variable_heights="variable_heights"
      :horizontal_header_height="horizontal_header_cell_height_default"
      :vertical_header_width="vertical_header_cell_width_default"
      :style="`height: ${max_component_height}px;`"
      :vertical_header_containee_class="['bg-blue']"
      :body_containee_y_class="['columnstore-viewer-row']"
      @fetch_data="fetch_data"
      class="w-100"
    >
      <template #horizontalheader="{nbx, width}">
        <columnstore-viewer-column-header
          :key="nbx"
          :style="width"
          v-bind="arguments_for_header(nbx)"
          v-on="header_events(arguments_for_header(nbx).name)"
        />
      </template>

      <template #verticalheader="{nby, height}">
        <div
          :key="nby"
          :style="height"
          class="lazy-table-vertical-header text-truncate"
        >
          {{ nby }}
        </div>
      </template>
      <template #bodycell="{nbx, nby, width, height}">
        <columnstore-viewer-body-cell
          :tokey="`${nbx}x${nby}`"
          :toclass="class_for_coords(nbx, nby)"
          :tostyle="width + height"
          :text="data_for_coords(nbx, nby)"
        >
        </columnstore-viewer-body-cell>
      </template>
    </lazy-display-frozenpanetable-xy>
  </div>
</template>
 -->
<!-- <template>
  <div>
    <lazy-display-frozenpanetable-xy
      :nbx="nbx"
      :nby="nby"
      :default_width="body_cell_width_default"
      :variable_width_start_pos="variable_width_start_pos"
      :variable_widths="variable_widths"
      :default_height="body_cell_height_default"
      :variable_height_start_pos="variable_height_start_pos"
      :variable_heights="variable_heights"
      :horizontal_header_height="horizontal_header_cell_height_default"
      :vertical_header_width="vertical_header_cell_width_default"
      class="w-100"
      :style="`height: ${max_component_height}px;`"
      :vertical_header_containee_class="['bg-blue']"
      :body_containee_y_class="['columnstore-viewer-row']"
      @fetch_data="fetch_data"
    >
      <template #horizontalheader="{nbx, width}">
        <columnstore-viewer-column-header
          :key="nbx"
          :style="width"
          v-bind="arguments_for_header(nbx)"
          v-on="header_events(arguments_for_header(nbx).name)"
        />
      </template>

      <template #verticalheader="{nby, height}">
        <div
          :key="nby"
          class="lazy-table-vertical-header text-truncate"
          :style="height"
        >
          {{ nby }}
        </div>
      </template>
      <template #bodycell="{nbx, nby, width, height}">
        <columnstore-viewer-body-cell
          :tokey="`${nbx}x${nby}`"
          :toclass="class_for_coords(nbx, nby)"
          :tostyle="width + height"
          :text="data_for_coords(nbx, nby)"
        >
        </columnstore-viewer-body-cell>
      </template>
    </lazy-display-frozenpanetable-xy>
  </div>
</template>
 -->
<style lang="scss">
@import '@/custom-bootstrap.scss';

$body-cell-width-default: 120px;
$body-cell-height-default: 20px;
$horizontal-header-cell-height-default: 120px;
$vertical-header-cell-width-default: 150px;

.columnstore-viewer-cell {
  font-size: medium;
  font-family: roboto mono, dejavu sans mono, courier, courier new, serif;
  background-color: white;
  color: $gray-900;
  border-left: 1px solid $gray-300;
  border-right: 0px;
  text-align: center;
  box-sizing: border-box;
}

.columnstore-viewer-row:hover > div > div {
  background-color: $lightblue;
}

.grey-background {
  background-color: $gray-100;
}

.columnstore-viewer-row > div > div:hover {
  color: $white;
  background-color: $blue;
}

.lazy-table-vertical-header {
  font-size: medium;
  font-family: roboto mono, dejavu sans mono, courier, courier new, serif;
  background-color: $blue;
  color: white;
  text-align: center;
  width: $vertical-header-cell-width-default;
  height: $body-cell-height-default;
}

.dropdown-toggle:empty::after {
  color: black;
}

.dropdown-toggle:empty {
  padding: 0;
}
</style>

<script>
import _ from 'lodash'
import $ from 'jquery'
import moment from 'moment'
import 'ion-rangeslider'

import Vue from 'vue'

import {
  get_columnstore_blocks_data,
  get_columnstore_general_metadata,
  get_columnstore_blocks_metadata,
} from '@/api/subscriptions.js'
import { display_format_element } from '@/components/columnstore_viewer_common.js'
import {
  lazy_scroll_subscriber_base,
  lazy_scroll_requester_base,
} from '@/components/lazy_list_requester.js'

import {
  subscription_mixin,
  poid_columnstore_metadata_subscription_string_maker,
} from '@/components/mixin.js'
import ColumnstoreViewerColumnHeader from '@/components/columnstore_viewer_column_header.vue'
import ColumnstoreViewerBodyCell from '@/components/columnstore_viewer_body_cell.vue'
import LazyDisplayFrozenpanetableXy from '@/components/lazy_display_frozenpanetable_xy.vue'

// *****************************************************************************

function coords_to_key(coords) {
  return _.join(coords, 'x')
}

function key_to_coords(key) {
  return _.map(key.split('x'), x => parseInt(x, 10))
}

function coord_to_key(coord) {
  return coord.toString()
}

function key_to_coord(key) {
  return parseInt(key, 10)
}

function get_fixed_text_width(nb_chars, is_title = false) {
  let text = document.createElement('span')
  document.body.appendChild(text)

  text.style.height = 'auto'
  text.style.width = 'auto'
  text.style.position = 'absolute'
  text.style.whiteSpace = 'no-wrap'
  text.innerHTML = 'M'.repeat(nb_chars)
  text.textAlign = 'center'
  text.borderLeft = '0.5px solid'
  text.borderRight = '0.5px solid'
  text.style.fontFamily = 'roboto mono'
  text.style.fontSize = 'medium'

  let width = $(text).width() + 1
  width = Math.ceil(width)

  document.body.removeChild(text)

  return width
}

function symbol_from_data_type(data_type) {
  let res
  if (data_type == 'number') {
    res = ['far', 'fa-tally']
  } else if (data_type == 'string') {
    res = ['far', 'fa-text']
  } else {
    res = ['fal', 'fa-clock']
  }
  return res
}

// *****************************************************************************

class lazy_scroll_columnstore_viewer_header_requester extends lazy_scroll_subscriber_base {
  initialize(reserve_keys, block_size, project_id, poid) {
    super.initialize(block_size)
    this.reserve_keys = reserve_keys
    this.project_id = project_id
    this.poid = poid
  }

  fetch_keys(needed_keys) {
    // console.log('fetch_keys')
    const project_id = this.project_id
    const poid = this.poid

    let real_keys = []
    for (const key of needed_keys) {
      const block_nb = parseInt(key, 10)
      const block_start = block_nb * this.block_size
      const block_stop = block_start + this.block_size
      // real_keys.push(
      //   `/project/${project_id}/pipe/${poid}/columnstore_metadata/${block_start}/${block_stop}`
      // )
      real_keys.push(
        poid_columnstore_metadata_subscription_string_maker(
          project_id,
          poid,
          block_start,
          block_stop
        )
        // `/project/${project_id}/pipe/${poid}/columnstore_metadata/${block_start}/${block_stop}`
      )
    }
    // console.log('lazy_scroll_columnstore_viewer_header_requester', real_keys)
    this.reserve_keys(
      'lazy_scroll_columnstore_viewer_header_requester',
      real_keys
    )
  }
}

// *****************************************************************************

class lazy_scroll_column_store_viewer_body_requester extends lazy_scroll_requester_base {
  reset_start_stop() {
    this.start = [undefined, undefined]
    this.stop = [undefined, undefined]
  }

  initialize(
    available_items,
    block_width,
    block_height,
    project_id,
    poid,
    sorting_desc
  ) {
    this.available_items = available_items
    this.block_width = block_width
    this.block_height = block_height
    this.project_id = project_id
    this.poid = poid
    this.sorting_desc = sorting_desc
  }

  range_is_empty_or_unchanged(start, stop) {
    const [startx, starty] = start
    const [stopx, stopy] = stop
    const [curstartx, curstarty] = this.start
    const [curstopx, curstopy] = this.stop

    const ok =
      startx === stopx ||
      starty === stopy ||
      (curstartx === startx &&
        curstarty === starty &&
        curstopx === stopx &&
        curstopy === stopy)
    this.start = start
    this.stop = stop
    return ok
  }

  compute_needed_keys() {
    const [startx, starty] = this.start
    const [stopx, stopy] = this.stop

    let block_startx = Math.floor(startx / this.block_width)
    let block_stopx = Math.floor(
      (stopx + this.block_width - 1) / this.block_width
    )

    let block_starty = Math.floor(starty / this.block_height)
    let block_stopy = Math.floor(
      (stopy + this.block_height - 1) / this.block_height
    )

    let needed_keys = new Set([])
    for (const x of _.range(block_startx, block_stopx)) {
      for (const y of _.range(block_starty, block_stopy)) {
        const key = coords_to_key([x, y])
        needed_keys.add(key)
      }
    }
    return needed_keys
  }

  async request_blocks(keys) {
    const requested_coords = _.map(keys, key_to_coords)
    const res = (await get_columnstore_blocks_data(
      this.project_id,
      this.poid,
      requested_coords,
      [this.block_width, this.block_height],
      this.sorting_desc
    )).pipe_object
    return res
  }
}

// *****************************************************************************

class table_sort_class {
  constructor() {
    // Holds a list of couples column_name: (sorting_index, asc or desc)
    // sorting_index starts at 1
    this.sort_by_col = {}
  }

  update_sort_order_after_pos(pos) {
    for (let [key, value] of Object.entries(this.sort_by_col)) {
      if (value[0] >= pos) {
        value[0] -= 1
      }
    }
  }

  force_column_sort(col_name, sort) {
    if (sort === 'ascending' || sort === 'descending') {
      // Best way to count the number of properties in an object...
      let nb_sorted_cols = Object.keys(this.sort_by_col).length
      let index = _.isUndefined(this.sort_by_col[col_name])
        ? nb_sorted_cols + 1
        : nb_sorted_cols

      let pos = (this.sort_by_col[col_name] || {})[0]

      this.update_sort_order_after_pos(pos)
      Vue.set(this.sort_by_col, col_name, [index, sort])
    }
  }

  reset_column_sort(col_name) {
    let couple = this.sort_by_col[col_name]
    if (!_.isUndefined(couple)) {
      let pos = couple[0]
      Vue.delete(this.sort_by_col, col_name)
      this.update_sort_order_after_pos(pos)
    }
  }

  get_col_sort(col_name) {
    const res = this.sort_by_col[col_name]
    return res
  }

  get_sorting_desc() {
    // Best way to count the number of properties in an object...
    let nb_sorted_cols = Object.keys(this.sort_by_col).length
    let res = _.times(nb_sorted_cols, undefined)
    for (let [col_name, [sorting_priority, sorting_order]] of Object.entries(
      this.sort_by_col
    )) {
      res[sorting_priority - 1] = { col_name, sorting_order }
    }
    return res
  }
}

// *****************************************************************************

function compute_column_width(column_metadata) {
  const nb_chars = Math.min(
    40,
    Math.max(
      column_metadata.name.length + 6,
      column_metadata.generic.body_recommended_nb_chars
    )
  )
  // +1 is for the border
  let width = get_fixed_text_width(nb_chars) + 1
  return width
}

// *****************************************************************************

const max_component_height = 720
const body_cell_width_default = 120
const body_cell_height_default = 20
const horizontal_header_cell_height_default = 120
const vertical_header_cell_width_default = 150
const data_block_width = 10
const data_block_height = 25

export default {
  name: 'ColumnstoreViewerMain',

  components: {
    LazyDisplayFrozenpanetableXy,
    ColumnstoreViewerColumnHeader,
    ColumnstoreViewerBodyCell,
  },

  mixins: [subscription_mixin],
  props: ['project_id', 'poid'],

  data() {
    return {
      metadata: undefined,
      sorting_logic: new table_sort_class(),

      body_data: {},
      startx: undefined,
      stopx: undefined,
      variable_height_start_pos: undefined,
      variable_heights: undefined,
      displayed_filter_tooltip_name: '',

      body_cell_width_default,
      body_cell_height_default,
      max_component_height,
      horizontal_header_cell_height_default,
      vertical_header_cell_width_default,
    }
  },

  computed: {
    sorting_desc() {
      return this.sorting_logic.get_sorting_desc()
    },
    nbx() {
      return (this.metadata || {}).nb_cols || 0
    },
    nby() {
      return (this.metadata || {}).nb_rows || 0
    },
    variable_width_start_pos() {
      return this.startx
    },
    variable_widths() {
      let columns_width = []

      if (!_.isUndefined(this.startx) && !_.isUndefined(this.stopx)) {
        let subscribed_objects = this.subscribed_objects
        // let available_keys = []

        for (let int_block_index of _.range(
          this.startx / data_block_width,
          this.stopx / data_block_width
        )) {
          const block_start = int_block_index * data_block_width
          const block_stop = block_start + data_block_width
          let to_add
          const key = poid_columnstore_metadata_subscription_string_maker(
            this.project_id,
            this.poid,
            block_start,
            block_stop
          )
          // let key = `/project/${this.project_id}/pipe/${
          //   this.poid
          // }/columnstore_metadata/${block_start}/${block_stop}`
          if (key in subscribed_objects) {
            // available_keys.push(block_start)
            to_add = _.map(_.compact(subscribed_objects[key]), x =>
              compute_column_width(x)
            )
          } else {
            const block_length = Math.min(
              data_block_width,
              this.nbx - int_block_index * data_block_width
            )
            to_add = _.times(
              block_length,
              _.constant(this.body_cell_width_default)
            )
          }
          columns_width = columns_width.concat(to_add)
        }
        // available_keys = _.sortBy(available_keys)
        // console.log('available_keys', this.startx, this.stopx, available_keys)
      }

      return columns_width
    },
  },

  watch: {
    project_id(nv) {
      this.full_refresh()
    },
    poid(nv) {
      this.full_refresh()
    },
  },

  beforeCreate() {
    this.$options.header_requester = new lazy_scroll_columnstore_viewer_header_requester()
    this.$options.data_requester = new lazy_scroll_column_store_viewer_body_requester()
  },

  beforeMount() {
    this.$options.header_requester.initialize(
      this.reserve_keys.bind(this),
      data_block_width,
      this.project_id,
      this.poid
    )
    this.$options.data_requester.initialize(
      this.body_data,
      data_block_width,
      data_block_height,
      this.project_id,
      this.poid,
      this.sorting_desc
    )
  },

  mounted() {
    this.fetch_metadata()
    this.$options.data_requester.reset()
  },

  methods: {
    async fetch_data(startx, stopx, starty, stopy) {
      startx = Math.floor(startx / data_block_width) * data_block_width
      stopx =
        Math.floor((stopx + data_block_width - 1) / data_block_width) *
        data_block_width
      starty = Math.floor(starty / data_block_height) * data_block_height
      stopy =
        Math.floor((stopy + data_block_height - 1) / data_block_height) *
        data_block_height
      this.$options.data_requester.update([startx, starty], [stopx, stopy])

      // Contiguous headers are kept
      if (!(_.isUndefined(this.startx) || _.isUndefined(this.stopx))) {
        if (stopx >= this.startx && this.stopx >= startx) {
          startx = Math.min(startx, this.startx)
          stopx = Math.max(stopx, this.stopx)
        }
      }
      // console.log(startx, stopx)
      this.startx = startx
      this.stopx = stopx
      this.$options.header_requester.update(startx, stopx)
    },
    async fetch_metadata() {
      this.metadata = (await get_columnstore_general_metadata(
        this.project_id,
        this.poid,
        this.filter
      )).pipe_object
    },
    class_for_coords(x, y) {
      let classes = ['columnstore-viewer-cell', 'text-truncate']
      if (y % 2 == 0) {
        classes.push('grey-background')
      }
      return classes
    },
    data_for_coords(x, y) {
      const block_x = Math.floor(x / data_block_width)
      const block_y = Math.floor(y / data_block_height)
      const key = _.join([block_x, block_y], 'x')

      let text = 'Loading...'
      if (key in this.body_data) {
        const block = this.body_data[key]
        if (!_.isUndefined(block)) {
          const pos_x = x % data_block_width
          const pos_y = y % data_block_height
          text = (block[pos_x] || [])[pos_y]

          let subscribed_objects = this.subscribed_objects
          let header_block_key = Math.floor(x / data_block_width)
          let header_block_start = header_block_key * data_block_width
          let header_block_stop = header_block_start + data_block_width

          header_block_key = poid_columnstore_metadata_subscription_string_maker(
            this.project_id,
            this.poid,
            header_block_start,
            header_block_stop
          )

          // header_block_key = `/project/${this.project_id}/pipe/${
          //   this.poid
          // }/columnstore_metadata/${header_block_start}/${header_block_stop}`

          if (header_block_key in subscribed_objects) {
            const header_key = x % data_block_width
            let column_metadata =
              subscribed_objects[header_block_key][header_key]
            text = display_format_element(
              text,
              column_metadata.generic.category,
              column_metadata.generic.body_display_format
            )
          }
        }
      }
      return text
    },
    arguments_for_header(x) {
      let subscribed_objects = this.subscribed_objects
      const block_index = Math.floor(x / data_block_width)
      const block_start = block_index * data_block_width
      const block_stop = block_start + data_block_width
      // console.log(poid_columnstore_metadata_subscription_string_maker)
      const block_key = poid_columnstore_metadata_subscription_string_maker(
        this.project_id,
        this.poid,
        block_start,
        block_stop
      )
      // const block_key = `/project/${this.project_id}/pipe/${
      //   this.poid
      // }/columnstore_metadata/${block_start}/${block_stop}`
      let key = x % data_block_width
      let res
      let loading = false
      let column_metadata
      let column_name
      // TODO: understand why subscribed_objects[block_key][key] can be null
      // when switching metavariables dicts
      if (
        !(block_key in subscribed_objects) ||
        !(key in subscribed_objects[block_key]) ||
        _.isNull(subscribed_objects[block_key][key])
      ) {
        loading = true
      } else {
        column_metadata = subscribed_objects[block_key][key]
        // console.log(JSON.stringify(column_metadata))
        column_name = column_metadata.name
      }

      let width = body_cell_width_default
      if (
        !_.isUndefined(this.variable_width_start_pos) &&
        !_.isUndefined(this.variable_widths) &&
        this.variable_widths.length !== 0
      ) {
        if (
          x >= this.variable_width_start_pos &&
          x < this.variable_width_start_pos + this.variable_widths.length
        ) {
          width = this.variable_widths[x - this.variable_width_start_pos]
        }
      }
      res = {
        project_id: this.project_id,
        poid: this.poid,
        name: column_name,
        column_infos: column_metadata,
        width,
        height: body_cell_height_default,
        displayed_filter_tooltip_name: this.displayed_filter_tooltip_name,
        versioned_filter: [0, undefined],
        loading,
        nb_rows: this.nby,
        sort: this.sorting_logic.get_col_sort(column_name),
      }

      return res
    },
    header_events(column_name) {
      let res = {
        sort_up: () => {
          this.sorting_logic.force_column_sort(column_name, 'ascending')
          this.$options.data_requester.sorting_desc = this.sorting_desc
          this.$options.data_requester.reset()
        },
        sort_down: () => {
          this.sorting_logic.force_column_sort(column_name, 'descending')
          this.$options.data_requester.sorting_desc = this.sorting_desc
          this.$options.data_requester.reset()
        },
        reset_sort: () => {
          this.sorting_logic.reset_column_sort(column_name)
          this.$options.data_requester.sorting_desc = this.sorting_desc
          this.$options.data_requester.reset()
        },
      }
      return res
    },
    full_refresh() {
      this.fetch_metadata()
      this.$options.header_requester.project_id = this.project_id
      this.$options.header_requester.poid = this.poid
      this.$options.header_requester.reset()
      this.$options.data_requester.project_id = this.project_id
      this.$options.data_requester.poid = this.poid
      this.$options.data_requester.reset()
    },
  },
}
</script>
